import { transparentize } from 'polished';

import {
  white,
  dark,
  paleGrey,
  brownishGrey,
  waterBlue,
  peacockBlue,
  sunflowerYellow,
  tangerine,
  lightGrey,
  sunflowerYellowGradient,
  alertRed,
} from '@g4/boneyard/lib/theme/colors';

import {
  greyA100,
  grey100,
  green700,
  grey900,
  blue700,
  lightBlue900,
  yellow100,
} from './theme/colors';
import common from './theme/colors.common';

const siteHeader = {
  light: {
    linkColor: peacockBlue,
    linkBackground: white,
  },
  dark: {
    linkColor: white,
    linkBackground: peacockBlue,
  },
  linkActive: tangerine,
  topBarBackground: {
    from: waterBlue,
    to: peacockBlue,
  },
  megaMenu: {
    separator: lightGrey,
    linkColor: dark,
  },
  boxShadow: lightGrey,
};

const siteFooter = {
  background: greyA100,
  title: peacockBlue,
  link: grey900,
  divider: grey100,
  copyright: peacockBlue,
};

const travelAdvisory = {
  background: paleGrey,
  title: peacockBlue,
  text: peacockBlue,
};

const checkbox = {
  active: peacockBlue,
  background: white,
  backgroundDisabled: lightGrey,
  backgroundActive: peacockBlue,
  checkmark: peacockBlue,
  checkmarkActive: white,
  checkmarkDisabled: brownishGrey,
  focused: common.form.focused,
  outline: peacockBlue,
  outlineDisabled: brownishGrey,
  stroke: lightGrey,
};

const datePicker = {
  background: {
    from: 'rgb(230, 233, 236)',
    to: white,
  },
  highlight: sunflowerYellowGradient,
  icons: {
    active: peacockBlue,
    activeBackground: {
      from: '#FFD200',
      to: '#FFB100',
    },
    disabled: brownishGrey,
  },
};

const fieldPlaceholderInfoText = {
  icon: {
    background: white,
    text: peacockBlue,
  },
  text: white,
};

const flightSearchForm = {
  textColor: white,
  background: {
    from: transparentize(0.15, waterBlue),
    to: peacockBlue,
  },
  travelersExpandoLabels: peacockBlue,
};

const input = {
  focused: common.form.focused,
  disabledText: brownishGrey,
  disabledBackground: white,
};

const popover = {
  background: peacockBlue,
  text: white,
};

const radio = {
  background: white,
  checked: peacockBlue,
  stroke: lightGrey,
};

const select = {
  disabledText: brownishGrey,
  disabledBackground: white,
  groupDivider: lightGrey,
  label: white,
  optionText: peacockBlue,
  placeholderText: brownishGrey,
  selected: dark,
};

const spinner = {
  light: white,
  dark: peacockBlue,
};

const emailSignUp = {
  stripBackground: peacockBlue,
  formBackground: paleGrey,
  border: tangerine,
  titleColor: white,
  textColor: peacockBlue,
  errorMessage: alertRed,
  successMessage: green700,
};

const focusStyle = `
  outline: none;
  box-shadow: 0 0 0 2px ${sunflowerYellow};
`;

const focusStyleInverted = `
  box-shadow: 0 0 0 1px ${peacockBlue};
`;

const section = {
  divider: {
    background: sunflowerYellow,
  },
};
/*
The z-indexes in the theme are the z-indexes for components whose stacking context
is the root stacking context. The components that are in a different stacking context
should have their z index defined in relation to that context, otherwise layering
issues might appear. For more details on z index and stacking contexts :
https://www.oreilly.com/library/view/developing-web-components/9781491905685/ch04.html and
https://philipwalton.com/articles/what-no-one-told-you-about-z-index/
For checking what stacking context a component is in you can use the Chrome extension z-context:
https://chrome.google.com/webstore/detail/z-context/jigamimbjojkdgnlldajknogfgncplbh
*/

const zIndex = {
  travelAdvisory: 1,
  emailSignUp: 1,
  siteHeader: 1000,
};

const ancillariesColors = {
  indicator: {
    isActive: lightBlue900,
    isNotActive: '#9e9e9e',
  },
  inactive: '#9e9e9e',
  active: peacockBlue,
  extrasCardText: grey900,
  extrasCardBackground: greyA100,
  popupText: grey900,

  bundleBanner: {
    background: '#fff6cc',
    mobileText: white,
  },

  bagsGrid: {
    border: grey100,
    header: lightBlue900, //headerTextDesktop
    headerBackgroundMobile: blue700,
    includedLabel: lightBlue900,
    includedBackground: yellow100,
    text: grey900,
    subsectionBackground: greyA100,
    checkBoxBackground: greyA100,
    priceBackground: '#EAF2F9',
    strikeThrough: '#716f6f',
    savingSection: '#FAFBFB',
  },
};

const defaultTheme = {
  colors: {
    link: common.link,
    linkActive: common.linkActive,
    siteHeader,
    siteFooter,
    travelAdvisory,
    checkbox,
    datePicker,
    fieldPlaceholderInfoText,
    flightSearchForm,
    input,
    popover,
    radio,
    select,
    section,
    spinner,
    emailSignUp,
    common,
  },
  focusStyle,
  focusStyleInverted,
  zIndex,
  ancillariesColors,
};

export default defaultTheme;
